

























































import Vue from 'vue'
import gql from 'graphql-tag'
import router from '@/router'
import InputField from '@/components/atoms/InputField.vue'
import { MdButton, MdCard, MdCheckbox, MdLayout, MdSnackbar } from 'vue-material/dist/components'
import CarrusIcon from '@/assets/svgs/carrus_icon.svg?inline'
import { ApolloError } from '@apollo/client'

Vue.use(MdButton)
Vue.use(MdCard)
Vue.use(MdCheckbox)
Vue.use(MdLayout)
Vue.use(MdSnackbar)
export default Vue.extend({
  name: 'CreateNewPassword',
  data: () => ({
    newPassword: '' as string,
    confirmPassword: '' as string,
    error: '' as string,
    sending: false
  }),
  components: {
    InputField,
    CarrusIcon
  },
  computed: {
    showError (): boolean {
      return !!this.error && this.error !== ''
    },
    changePasswordId (): string {
      return this.$route.params.changePasswordId
    }
  },
  methods: {
    submit: async function () {
      // validate matching passwords before saving
      if (this.newPassword !== this.confirmPassword) {
        this.error = this.$t('errors.passwordsMustMatch') as string
      } else {
        try {
          this.error = ''
          this.sending = true
          await this.$apollo.mutate({
            // Query
            mutation: gql`mutation {
              changePassword(
                body: {
                  changePasswordId: "${this.changePasswordId}",
                  password: "${this.newPassword}",
                }
              ) {
                oneTimePassword
              }
            }`
          })
          this.error = ''
          router.push({ path: '/login' })
        } catch (err) {
          const { graphQLErrors } = (err as ApolloError)
          const mappedErrorExtensions = graphQLErrors.map((e) => e.extensions).filter(ext => ext !== undefined)
          // check for field errors. we only have one field to worry about here
          if (mappedErrorExtensions) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.error = mappedErrorExtensions.map((ext) => (ext as { [key: string]: any }).response.body.fieldErrors.password.map((f) => f.message)).join(' ')
          } else {
            // otherwise use higher level error messages
            this.error = graphQLErrors.map((e) => e.message).join(' ')
          }
        } finally {
          this.sending = false
        }
      }
    }
  }
})
